enum ModeType{
    LIGHT, DARK
}

export default ModeType;